import { Loader2 } from 'lucide-react';

import type { CttqPreviewResult } from '../../services/cttqService';
import { formatCoveragePercent } from '../../services/cttqService';

type TtqCttqRedundancyModalProps = {
  open: boolean;
  preview: CttqPreviewResult | null;
  creating: boolean;
  onClose: () => void;
  onConfirmCreate: (acknowledged: boolean) => void;
};

export function TtqCttqRedundancyModal({
  open,
  preview,
  creating,
  onClose,
  onConfirmCreate,
}: TtqCttqRedundancyModalProps) {
  if (!open || !preview) {
    return null;
  }

  const score = preview.redundancyReport.redundancyScore;
  const high = score >= 0.75;
  const warn = score >= 0.55;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="max-h-[85vh] w-full max-w-lg overflow-y-auto rounded-2xl border border-border bg-surface p-6 shadow-card">
        <h3 className="text-lg font-semibold text-ink">
          {high ? '聚合冗余偏高' : warn ? '与已有聚合题重叠较高' : '创建收敛品题'}
        </h3>
        <p className="mt-2 text-sm font-medium text-danger">
          冗余分 {Math.round(score * 100)}%
        </p>
        <p className="text-sm text-muted">
          预计覆盖度 {formatCoveragePercent(preview.coverageReport.overallScore)}
        </p>
        <ul className="mt-4 space-y-2 text-sm text-ink">
          {preview.redundancyReport.warnings.map((warning) => (
            <li key={warning}>• {warning}</li>
          ))}
          {preview.redundancyReport.overlappingRecords.slice(0, 3).map((item) => (
            <li key={item.cttqRecordId} className="text-muted">
              与「{item.label || item.cttqRecordId.slice(0, 8)}」member 重叠 {Math.round(item.memberSetJaccard * 100)}%
            </li>
          ))}
        </ul>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            className="rounded-lg border border-border px-4 py-2 text-sm text-ink hover:bg-black/5"
            onClick={onClose}
            disabled={creating}
          >
            取消
          </button>
          <button
            type="button"
            className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90 disabled:opacity-60"
            onClick={() => onConfirmCreate(high)}
            disabled={creating}
          >
            {creating ? '创建中…' : high ? '仍要创建（低优先级）' : '确认创建'}
          </button>
        </div>
        {creating ? <Loader2 className="mx-auto mt-3 animate-spin text-primary" size={20} /> : null}
      </div>
    </div>
  );
}
